/* ============================================
   AANYA Product Card Interactivity
   - Quick Add (AJAX add-to-cart for the default variant)
   - Wishlist toggle (localStorage-backed)
   Delegated: works for cards rendered anywhere on the page.
   ============================================ */

(function () {
  var WISHLIST_KEY = 'aanya_wishlist';

  function getCustomerStorageKey() {
    if (window.AanyaCustomer && window.AanyaCustomer.id) {
      return 'aanya_wishlist_customer_' + window.AanyaCustomer.id;
    }
    return null;
  }

  function getWishlist() {
    try {
      var custKey = getCustomerStorageKey();
      if (custKey) {
        var custData = localStorage.getItem(custKey);
        if (custData) return JSON.parse(custData);
      }
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      var custKey = getCustomerStorageKey();
      if (custKey) {
        localStorage.setItem(custKey, JSON.stringify(list));
      }
    } catch (e) {}
  }

  function syncCustomerWishlistOnLogin() {
    try {
      var custKey = getCustomerStorageKey();
      if (!custKey) return;

      var guestList = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      var custList = JSON.parse(localStorage.getItem(custKey) || '[]');
      
      var map = {};
      custList.forEach(function(item) { map[String(item.id)] = item; });
      guestList.forEach(function(item) {
        if (!map[String(item.id)]) {
          item.customerId = window.AanyaCustomer.id;
          item.customerEmail = window.AanyaCustomer.email;
          item.userType = 'customer';
          custList.unshift(item);
          map[String(item.id)] = item;
        }
      });

      localStorage.setItem(custKey, JSON.stringify(custList));
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(custList));
    } catch (e) {}
  }

  function syncWishlistButton(btn) {
    if (!btn) return;
    var id = btn.dataset.productId;
    var active = getWishlist().some(function (p) {
      return String(p.id) === String(id);
    });
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    var card = btn.closest('.aanya-product-card');

    if (!variantId) {
      if (card) window.location = card.getAttribute('href');
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      drawer.getSectionsToRender().forEach(function (section) {
        body.append('sections[]', section.id);
      });
      body.append('sections_url', window.location.pathname);
      drawer.setActiveElement(btn);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) { return response.json(); })
      .then(function (resp) {
        btn.classList.remove('is-loading');

        if (resp.status) {
          btn.disabled = false;
          btn.textContent = originalText;
          return;
        }

        btn.textContent = 'Added to Bag';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 1800);

        try {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: resp });
        } catch (err) {}

        if (drawer && typeof drawer.renderContents === 'function') {
          setTimeout(function () {
            try { drawer.renderContents(resp); } catch (err2) {}
          }, 60);
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function updateGlobalWishlistBadges() {
    var list = getWishlist();
    var badges = document.querySelectorAll('.aanya-wishlist-count, #header-wishlist-badge, #aanya-nav-wishlist-badge');
    badges.forEach(function (b) {
      if (list.length > 0) {
        var txt = b.querySelector('span') || b;
        txt.textContent = list.length;
        b.style.display = 'flex';
      } else {
        b.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncCustomerWishlistOnLogin();
    document.querySelectorAll('[data-wishlist-add]').forEach(syncWishlistButton);
    updateGlobalWishlistBadges();

    document.addEventListener('click', function (event) {
      var wishlistBtn = event.target.closest('[data-wishlist-add]');
      if (wishlistBtn) {
        event.preventDefault();
        event.stopPropagation();
        var wId = wishlistBtn.dataset.productId;
        var card = wishlistBtn.closest('.aanya-product-card, .card-wrapper, .grid__item');
        
        var wTitle = '';
        var wUrl = '';
        var wImage = '';
        var wPrice = '';
        var wVariantId = '';
        var wHandle = '';

        if (card) {
          var nameEl = card.querySelector('.aanya-product-card__name, .card__heading, h3');
          if (nameEl) wTitle = nameEl.textContent.trim();
          var linkEl = card.querySelector('a[href*="/products/"]');
          if (linkEl) {
            wUrl = linkEl.getAttribute('href');
            var parts = wUrl.split('/products/');
            if (parts.length > 1) wHandle = parts[1].split('?')[0];
          }
          var imgEl = card.querySelector('.aanya-product-card__image--primary, .card__media img, img');
          if (imgEl) wImage = imgEl.currentSrc || imgEl.src;
          var priceEl = card.querySelector('.aanya-price, .price-item--sale, .price-item--regular');
          if (priceEl) wPrice = priceEl.textContent.trim();
          var quickBtn = card.querySelector('[data-variant-id]');
          if (quickBtn) wVariantId = quickBtn.dataset.variantId;
        } else {
          // PDP Context
          var titleEl = document.querySelector('.product__title h1, .product__title h2');
          if (titleEl) wTitle = titleEl.textContent.trim();
          wUrl = window.location.pathname;
          var parts = wUrl.split('/products/');
          if (parts.length > 1) wHandle = parts[1].split('?')[0];
          var pdpImg = document.querySelector('.product__media img, .aanya-sticky-atc__thumb');
          if (pdpImg) wImage = pdpImg.currentSrc || pdpImg.src;
          var pdpPrice = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular, .aanya-sticky-atc__price');
          if (pdpPrice) wPrice = pdpPrice.textContent.trim();
          var variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
          if (variantInput) wVariantId = variantInput.value;
        }

        var list = getWishlist();
        var idx = list.findIndex(function (p) { return String(p.id) === String(wId); });
        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          var customerInfo = window.AanyaCustomer || {};
          list.unshift({
            id: wId,
            title: wTitle || 'Fine Jewellery Piece',
            url: wUrl || window.location.pathname,
            handle: wHandle,
            image: wImage,
            price: wPrice,
            variantId: wVariantId,
            customerId: customerInfo.id || null,
            customerEmail: customerInfo.email || null,
            customerName: customerInfo.name || null,
            userType: customerInfo.isLoggedIn ? 'customer' : 'guest',
            ts: Date.now()
          });
        }
        setWishlist(list);
        
        // Sync all wishlist buttons with this product ID
        document.querySelectorAll('[data-wishlist-add][data-product-id="' + wId + '"]').forEach(syncWishlistButton);
        updateGlobalWishlistBadges();
        window.dispatchEvent(new CustomEvent('aanya:wishlist:updated', { detail: { list: list } }));
        return;
      }

      var quickAddBtn = event.target.closest('[data-quick-add]');
      if (quickAddBtn && !quickAddBtn.disabled) {
        event.preventDefault();
        event.stopPropagation();
        addToCart(quickAddBtn);
      }
    });
  });
})();